import { render, staticRenderFns } from "./update-internal-news.vue?vue&type=template&id=4f968191"
import script from "./update-internal-news.vue?vue&type=script&lang=js"
export * from "./update-internal-news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports